module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--8-639f549139205b648092d1ba76e62088.jpg";